import React, { useState, useEffect } from 'react';
import TableWrapper from '../../components/Grid';
import { Col, Row, Avatar } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined, UserOutlined, SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AddUserSchema } from '../../config/Schema';
import { TextField, ScrollEndMessage } from '../../components';
import SelectField from '../../components/TextField/SelectField';
import Button from '../../components/Button';
import { Colors } from '../../config';
import { FaEye } from 'react-icons/fa';
import { FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import ActionDropdown from '../../components/DropDown/actiondropdown';
import { IoIosPower } from 'react-icons/io';
import { SiteManagementAction } from '../../store/actions';
import { Spin } from 'antd';
import useColors from '../../hooks/useColors';

const SiteManagement = () => {
    const { colorPrimary } = useColors();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.AppReducer?.user);
    const isRole = user?.userRole[0];

    const { properties, loader } = useSelector(
        (state) => state?.SiteManagementReducer,
    );
    const propertyError = useSelector((state) => state?.SiteManagementReducer?.propertyError);

    console.log('properties?.data', properties?.paginate?.total);

    const [state, setState] = useState({
        current: 1,
        limit: 20,
        searchVal: '',
        tabName: 'active',
        sortBy: 'name',
        sortOrder: 'desc',
        user: user,
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [accumulatedProperties, setAccumulatedProperties] = useState([]);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            setState((prev) => ({
                ...prev,
                current: 1,
                searchVal: searchTerm,
            }));
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    useEffect(() => {
        dispatch(SiteManagementAction.GetProperty(state));
    }, [state.current, state.limit, state.searchVal, state.sortBy, state.sortOrder]);

    useEffect(() => {
        setAccumulatedProperties([]);
    }, [state.searchVal, state.sortBy, state.sortOrder]);

    useEffect(() => {
        if (properties?.data) {
            if (state.current === 1) {
                setAccumulatedProperties(properties.data);
            } else {
                setAccumulatedProperties((prev) => {
                    const existingIds = new Set(prev.map((p) => p.id));
                    const newProperties = properties.data.filter((p) => !existingIds.has(p.id));
                    return [...prev, ...newProperties];
                });
            }
        }
    }, [properties, state.current]);

    useEffect(() => {
        if (propertyError) {
            setAccumulatedProperties([]);
        }
    }, [propertyError]);

    const paginate = properties?.paginate;
    const hasMore = paginate ? (paginate.currentPage < paginate.lastPage) : true;

    useEffect(() => {
        const container = document.querySelector('.site-layout .ant-layout-content');
        if (!container) return;

        const handleScroll = () => {
            const isNearBottom = container.scrollHeight - container.scrollTop <= container.clientHeight + 100;
            if (isNearBottom && !loader && hasMore) {
                setState((prev) => ({
                    ...prev,
                    current: prev.current + 1,
                }));
            }
        };

        container.addEventListener('scroll', handleScroll);
        return () => container.removeEventListener('scroll', handleScroll);
    }, [loader, hasMore]);

    // user Select values filter handler
    const SelectFilterHandler = (value) => {
        setState((prev) => ({
            ...prev,
            current: 1,
            sortBy: 'name',
            sortOrder: value,
        }));
    };
    // Add New User handler
    const AddProperty = () => navigate('/add-property');

    const items = [
        {
            label: 'View and Edit Details',
            key: 1,
            icon: <FaEye color="#6A9BFF" />,
            backgroundColor: '#eef4ff',
            color: '#4582ff',
        },
        // {
        //     label: 'Delete',
        //     key: 2,
        //     icon: <FaTrash color="#E71D36" />,
        //     backgroundColor: '#fef3f5',
        //     color: '#e93148',
        // },
    ];

    const ActionHandler = (e, record) => {
        if (e.key == '1') {
            navigate(`/property-details/${record?.id}`);
            return;
        } else {
            let payload = {
                id: Number(record?.id),
                status: 'active',
            };
            dispatch(
                SiteManagementAction.UpdatePropertyStatus(payload, () => {
                    setAccumulatedProperties([]);
                    setState((prev) => ({ ...prev, current: 1 }));
                    if (state.current === 1) {
                        dispatch(SiteManagementAction.GetProperty({ ...state, current: 1 }));
                    }
                }),
            );
        }
    };

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const columns = [
        {
            title: 'Client',
            dataIndex: 'propertyImg',
            key: 'propertyImg',
            align: 'left',
            render: (text, record) => (
                <Row
                    justify={'center'}
                    style={{ display: 'flex', alignItems: 'center' }}
                >
                    <Col span={24} className="flex justify-start items-center">
                        {record?.propertyImg &&
                            record.propertyImg.length > 0 ? (
                            <Avatar
                                className="mr-5"
                                size={40}
                                src={record.propertyImg[0]?.url}
                            />
                        ) : (
                            <Avatar
                                className="mr-5"
                                size={40}
                                icon={<UserOutlined />}
                            />
                        )}
                        <span>{record?.company[0]?.name}</span>
                    </Col>
                </Row>
            ),
        },
        {
            title: 'Location Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Property Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'Action',
            dataIndex: 'id',
            key: 'id',
            align: 'left',
            render: (text, record) => {
                return (
                    <Col
                        span={24}
                        className="flex justify-start align-center text-center"
                    >
                        <ActionDropdown
                            items={items}
                            placement={'bottom'}
                            labelStyle={{
                                color: colorPrimary,
                                fontSize: '1.2rem',
                                marginBottom: '7px',
                            }}
                            onClick={(e) => ActionHandler(e, record)}
                            isRole={isRole}
                        />
                    </Col>
                );
            },
        },
    ];

    const handleRowClick = (record) => {
        navigate(`/property-details/${record?.id}`);
    };

    return (
        <>
            <div className="w-full flex items-center justify-between gap-3 my-4" style={{ flexWrap: 'wrap' }}>
                <h1 className="text-xl font-semibold m-0" style={{ flexShrink: 0 }}>Site Management</h1>
                <div className="flex items-center gap-3" style={{ flexShrink: 0 }}>
                    <div style={{ width: '260px' }}>
                        <TextField.Basic
                            style={{ background: '#eff2f5', width: '100%', margin: 0 }}
                            suffix={<SearchOutlined style={{ fontSize: '18px', color: '#888' }} />}
                            placeholder="Search..."
                            onChange={(e) => handleInputChange(e)}
                            id="search"
                            name="search"
                            value={searchTerm}
                            className="placeholder-red outline-none w-full py-2 px-4"
                        />
                    </div>

                    <div style={{ width: '160px', flexShrink: 0 }}>
                        <SelectField
                            defaultValue={'desc'}
                            style={{ backgroundColor: '#eff2f5' }}
                            className="w-full h-10"
                            onChange={(val) => SelectFilterHandler && SelectFilterHandler(val)}
                            options={optionsSelect}
                            placeholder="Descending"
                        />
                    </div>

                    {(isRole === 'admin' || isRole === 'manager') && (
                        <Button.Basic
                            className="text-white outline-none border-none cursor-pointer"
                            style={{
                                height: '40px',
                                flexShrink: 0,
                                background: colorPrimary,
                                color: Colors.White,
                                paddingLeft: '20px',
                                paddingRight: '20px',
                                borderRadius: '8px',
                                fontWeight: 500,
                                letterSpacing: '0.3px',
                            }}
                            text="Add New Property"
                            icon={<PlusOutlined />}
                            onClick={() => AddProperty && AddProperty()}
                        />
                    )}
                </div>
            </div>

            <Row
                gutter={[8, 32]}
                style={{ padding: '16px' }}
                className="bg-white rounded-lg w-fit sm:w-fit md:w-full lg:w-full xl:w-full"
            >
                <Col span={24} className="w-full">
                    <TableWrapper
                        className="rounded-lg w-full"
                        headerbg={'red'}
                        tableColumns={columns}
                        tableData={accumulatedProperties}
                        pagination={false}
                        rowClassName={'row-antd'}
                        onRow={(record) => ({
                            onClick: () => handleRowClick(record),
                        })}
                    />
                    {loader && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
                            <Spin />
                        </div>
                    )}
                    <ScrollEndMessage
                        hasMore={hasMore}
                        loading={loader}
                        dataLength={accumulatedProperties?.length}
                    />
                </Col>
            </Row>
        </>
    );
};

export default SiteManagement;

var optionsSelect = [
    {
        value: 'asc',
        label: 'Ascending',
    },
    {
        value: 'desc',
        label: 'Descending',
    },
];
